export default "__VITE_ASSET__d557e6a9__"